import { TimeUnit } from '../constants/time';

// eslint-disable-next-line import/prefer-default-export
export const getUTCTimestamp = (): number => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * TimeUnit.Minute;

  return now.getTime() + timezoneOffset;
};
